var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Card", {
        attrs: { title: "Create Playlist" },
        scopedSlots: _vm._u([
          {
            key: "button",
            fn: function() {
              return [
                _c("Button", {
                  attrs: { variant: "default", label: "Cancel" },
                  on: { clicked: _vm.goBack }
                }),
                _vm._v(" "),
                _c("Button", {
                  attrs: { variant: "primary", label: "Save" },
                  on: { clicked: _vm.submit }
                })
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "flex flex-col" },
                  [
                    _c(
                      "h5",
                      {
                        staticClass:
                          "text-gray-700 text-sm mt-3 mb-6 font-bold uppercase text-left"
                      },
                      [_vm._v("\n          Playlist Form\n        ")]
                    ),
                    _vm._v(" "),
                    _c("form-item", {
                      attrs: { label: "Playlist Name" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("Input", {
                                attrs: {
                                  placeholder: "Name",
                                  error:
                                    _vm.$v.name.$dirty && !_vm.$v.name.required
                                },
                                model: {
                                  value: _vm.name,
                                  callback: function($$v) {
                                    _vm.name = $$v
                                  },
                                  expression: "name"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex flex-col pt-2" },
                                [
                                  _vm.$v.name.$dirty && !_vm.$v.name.required
                                    ? _c("text-error", {
                                        attrs: {
                                          text: "Please fill Playlist Name."
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "flex flex-col border-b border-gray-200 py-3"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex justify-between" },
                      [
                        _c(
                          "h5",
                          {
                            staticClass:
                              "text-gray-700 text-sm py-2 font-bold uppercase"
                          },
                          [_vm._v("\n            Video List\n          ")]
                        ),
                        _vm._v(" "),
                        _c("Button", {
                          attrs: {
                            variant: "outline-primary",
                            label: "Add Video"
                          },
                          on: {
                            clicked: function($event) {
                              _vm.isShowingModal = true
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.isVideosEmpty
                      ? _c("text-error", {
                          attrs: { text: "Videos cannot be empty" }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.dataVideos.length > 0
                  ? _c(
                      "el-table-draggable",
                      { attrs: { handle: ".handle-move" } },
                      [
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              data: _vm.dataVideos,
                              "row-key": "id",
                              "show-header": false
                            }
                          },
                          [
                            _c(
                              "el-table-column",
                              {
                                key: "handle",
                                attrs: { label: "Handle", align: "center" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "static inline-block text-center container-action handle-move",
                                    staticStyle: { cursor: "move" }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { size: "2x", icon: ["fa", "th"] }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.tableColumn, function(column) {
                              return _c("el-table-column", {
                                key: column.prop,
                                attrs: {
                                  prop: column.prop,
                                  label: column.label,
                                  sortable: "custom"
                                }
                              })
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "Thumbnail",
                                align: "left",
                                width: "150px"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("img", {
                                          attrs: {
                                            src: scope.row.thumbnail,
                                            alt: ""
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                4031789611
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { label: "Actions", align: "right" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "static inline-block text-left container-action"
                                          },
                                          [
                                            _c(
                                              "VueCustomTooltip",
                                              {
                                                attrs: {
                                                  label: "Delete",
                                                  position: "is-left"
                                                }
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "p-2 mr-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.removeFromList(
                                                          scope.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "text-white",
                                                      attrs: {
                                                        icon: [
                                                          "fa",
                                                          "trash-alt"
                                                        ]
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2837293778
                              )
                            })
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataVideos.length === 0
                  ? _c(
                      "div",
                      { staticClass: "flex justify-center py-6 text-sm" },
                      [
                        _vm._v(
                          "\n        No videos added. Please add a videos to continue\n      "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "ModalDialog",
        {
          ref: "addVideos",
          attrs: {
            size: "xlarge",
            isShowingModal: _vm.isShowingModal,
            title: "Add Videos to Playlist",
            labelSubmit: "Submit"
          },
          on: {
            toggleModal: function($event) {
              _vm.isShowingModal = !_vm.isShowingModal
            },
            save: function($event) {
              return _vm.submitAddVideos()
            }
          }
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("SearchVideos", {
                ref: "addVideosContent",
                attrs: {
                  "toggle-reset": _vm.isShowingModal,
                  "taken-videos": _vm.dataVideos,
                  "channel-id": _vm.channelId
                },
                on: { "on-submit-videos": _vm.addVideosPlaylist }
              })
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-345ac740", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-345ac740","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/MissionsVideos/Channel/CreatePlaylist.vue
// module id = null
// module chunks = 